angular.module("vgresiduos").controller("DisposalNotificationPopupCtrl", [
	"$scope",
	"dialogService",
	"disposalId",
	"transporter",
	"$timeout",
	function ($scope, dialogService, disposalId, transporter, $timeout) {
		"use strict";

		$scope.disposalId = disposalId;
		$scope.queries = [
			{ label: "dialog", value: "notify" },
			{ label: "transporter", value: transporter }
		];

		$scope.$on(Vgr.constants.evtIframeHeight, function (event, data) {
			var dialog = document.getElementsByTagName("md-dialog")[0];
			if (dialog) {
				dialog.style.height = Math.min(data.data.payload.height - data.data.payload.height * 0.2, 420) + "px";
			}
		});

		$scope.$on(Vgr.constants.evtIframeOnCancelDisposalDialogPagePopUp, function (event, data) {
			dialogService.hide($scope.dialog);
		});
	}
]);
